import React from 'react';
import {withRouter} from 'react-router-dom';
import queryString from 'query-string';
import {Alert} from '@betareader/design-system';
import VerifyEmail from './verifyEmail';

export const UserAction = ({location}) => {
  const {mode, oobCode} = queryString.parse(location.search);
  if (['recoverEmail', 'verifyEmail', 'verifyAndChangeEmail'].includes(mode)) {
    return <div className="br-user-action"><VerifyEmail actionCode={oobCode} /></div>;
  }
  return (
    <div className="br-user-action">
      <Alert variant="error">
        <strong>Something went wrong.</strong> You should only end up here if you've tried to change your email or password. If that's what you were trying to do, please contact info@betareader.io.
      </Alert>
    </div>
  );
};

export default withRouter(UserAction);
